import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class NachrichtFormFocusService {

    focusFirstInvalid(formControls: { [key: string]: any }) {
        // 1) Name des ersten invaliden Controls ermitteln
        const firstInvalidKey = Object.keys(formControls)
            .find(key => formControls[key].invalid);
        if (!firstInvalidKey) {
            return;
        }

        // 2) Wrapper-Element via name-Attribut finden
        const selector = `[name="${firstInvalidKey}"]`;
        const invalidEl = document.querySelector<HTMLElement>(selector);
        if (!invalidEl) {
            return;
        }

        // 3) Scrollen
        invalidEl.scrollIntoView({behavior: 'smooth', block: 'start'});

        // 4) Fokus setzen
        // 4a) Für File-Uploader: erst <li class="ba-upload-error"> holen, dann Button fokussieren
        const errorLi = invalidEl.querySelector<HTMLLIElement>('li.ba-upload-error');
        if (errorLi) {
            const deleteBtn = errorLi.querySelector<HTMLButtonElement>('button.ba-upload-delete');
            if (deleteBtn) {
                deleteBtn.focus();
            }
        } else {
            // 4b) Suche nach <input> oder <textarea> innerhalb des Wrappers
            const field = invalidEl.querySelector<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
            if (field) {
                field.focus();
            }
        }
    }
}
